function AddMessaginPerformanceIcon(props) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule={'evenodd'}
        d="M8 7H24C25.1 7 26 7.9 26 9V21C26 22.1 25.1 23 24 23H10L6 27V9C6 7.9 6.9 7 8 7ZM13 16H10V20H13V16ZM14.5 14H17.5V20H14.5V14ZM22 11H19V20H22V11Z"
        fill="#A8ADB2"
      />
    </svg>
  )
}

export default AddMessaginPerformanceIcon
